import React from 'react'

export default function SubGroup({categories,selectedCategory,y,x,selectCategory,setSelectedCategory}) {
  const [openable,setOpenable]=React.useState(","+x.id+",");
  const [open,setOpen]=React.useState(false)
  
  return (
    <li >
    {
      (categories.filter(z=>z.parent_category_id==y.id)).length>0 ? 
      <button style={{color:'#000'}} onClick={()=>setOpen(!open)}>{open ? '-' :'+'}</button>
      :
      <></>
    }
    <span  className={(selectedCategory!=null && selectedCategory.id==y.id ? 'category-list category-active' : 'category-list')} onClick={()=>{
      selectCategory(y);
    
      setOpenable(","+x.parent_category_id+","+","+y.parent_category_id+","+","+(categories.filter(p=>p.id==x.parent_category_id)).id+","+","+(categories.filter(p=>p.id==y.parent_category_id)).id+",")
    }}> 
    {y.name.replace("P-","").replace("S-","").replace("K-","")}</span>
    {
      
      (categories.filter(z=>z.parent_category_id==y.id)).length>0 ? 
        <ul style={{display:open?'block':'none'}}>
          {
            (categories.filter(z=>z.parent_category_id==y.id)).map(z=>{
              return (
                <SubGroup key={"sub-s-"+(Math.floor(Math.random()*100))+z.id} categories={categories} y={z} x={y} selectedCategory={selectedCategory} selectCategory={selectCategory} setSelectedCategory={setSelectedCategory}  />
              )
            })
          }
        </ul>
        :
        <></>
    }
    </li>
  )
}
